import React from "react";
import { Link } from "react-router-dom";

const fmt = v => (v === null || v === undefined || v === "" ? "—" : String(v));

export const ImportRowsTable = ({ preview, selected, onToggle, onToggleAll, disabled }) => {
  const selectable = preview.rows.filter(r => r.valid && !r.already_imported);
  const allSelected = selectable.length > 0 && selectable.every(r => selected.has(r.row_number));
  return <section className="border border-border bg-white" data-testid="rfq-import-rows">
    <div className="px-5 py-3 border-b border-border flex flex-wrap items-center justify-between gap-2">
      <h2 className="text-lg font-semibold">Righe trovate</h2>
      <p className="text-xs text-muted-foreground" data-testid="rfq-import-summary">{preview.summary.total} righe · {preview.summary.valid} importabili · {preview.summary.invalid} escluse · {preview.summary.with_issues} con segnalazioni{preview.summary.already_imported ? ` · ${preview.summary.already_imported} già importate` : ""}</p>
    </div>
    <div className="overflow-x-auto">
      <table className="dense-table w-full">
        <thead><tr>
          <th><input type="checkbox" aria-label="Seleziona tutte le righe importabili" data-testid="rfq-import-select-all" checked={allSelected} disabled={disabled || !selectable.length} onChange={e => onToggleAll(e.target.checked)} /></th>
          <th>Riga</th><th>Codice</th><th>Descrizione</th><th className="text-right">Q.tà</th><th>Materiale</th><th className="text-right">Sp. mm</th><th>Note</th><th>Rif.</th><th>Segnalazioni</th>
        </tr></thead>
        <tbody>
          {preview.rows.map(r => {
            const v = r.values, imported = r.already_imported;
            return <tr key={r.row_number} data-testid={`rfq-import-row-${r.row_number}`} className={!r.valid ? "opacity-50" : ""}>
              <td><input type="checkbox" aria-label={`Seleziona riga ${r.row_number}`} data-testid={`rfq-import-select-${r.row_number}`} checked={selected.has(r.row_number)} disabled={disabled || !r.valid || !!imported} onChange={() => onToggle(r.row_number)} /></td>
              <td className="font-mono text-xs">{r.row_number}</td>
              <td className="font-mono" data-testid={`rfq-import-code-${r.row_number}`}>{fmt(v.item_code)}</td>
              <td className="max-w-xs truncate">{fmt(v.description)}</td>
              <td className="text-right font-mono" data-testid={`rfq-import-qty-${r.row_number}`}>{fmt(v.quantity)}</td>
              <td>{fmt(v.material)}</td>
              <td className="text-right font-mono">{fmt(v.thickness_mm)}</td>
              <td className="max-w-xs truncate">{fmt(v.notes)}</td>
              <td className="font-mono text-xs">{fmt(v.reference)}</td>
              <td className="text-xs" data-testid={`rfq-import-issues-${r.row_number}`}>
                {imported && <Link className="underline text-muted-foreground" to={`/rfqs/${imported.rfq_id}`}>Già importata → {imported.reference}</Link>}
                {r.issues.map((i, k) => <div key={k} className="text-amber-800">{i}</div>)}
              </td>
            </tr>;
          })}
        </tbody>
      </table>
    </div>
  </section>;
};
